function navigationSecond(submenu) {
	const parentMenuItem = submenu.parentNode;
	const siblingMenus = window._farlo.helpers.getSiblings(submenu);

	const openMenu = (item, menu) => {
		item.classList.add('site-navigation-second__menu-item--active');
		menu.classList.add('site-navigation-second__sub-menu--active');
		menu.setAttribute('aria-hidden', 'false');
		item.setAttribute('aria-expanded', 'true');
	};

	const closeMenu = (item, menu) => {
		item.classList.remove('site-navigation-second__menu-item--active');
		menu.classList.remove('site-navigation-second__sub-menu--active');
		menu.setAttribute('aria-hidden', 'true');
		item.setAttribute('aria-expanded', 'false');

	};

	const closeAllMenus = () => {
		siblingMenus.forEach((sibling) => {
			const siblingItem = sibling.children[0];
			const siblingMenu = sibling.children[1];
			if (siblingItem && siblingItem.classList.contains('site-navigation-second__menu-item--active')) {
				closeMenu(siblingItem, siblingMenu);
			}
		});

	};

	const handleKeyDown = (e) => {
		const doc = parentMenuItem.ownerDocument;
		const activeElement = doc.activeElement;
		const items = Array.from(parentMenuItem.querySelectorAll('.site-navigation-second__menu-link'));
		const currentIndex = items.indexOf(activeElement);
		let newIndex = -1;

		switch (e.key) {
			case 'ArrowDown':
				e.preventDefault();
				newIndex = (currentIndex + 1) % items.length;
				items[newIndex].focus();
				break;
			case 'ArrowUp':
				e.preventDefault();
				newIndex = (currentIndex - 1 + items.length) % items.length;
				items[newIndex].focus();
				break;
			case 'ArrowRight':
				if (submenu.classList.contains('site-navigation-second__sub-menu--active')) {
					e.preventDefault();
					const firstSubmenuItem = submenu.querySelector('.site-navigation-second__menu-link');
					if (firstSubmenuItem) {
						firstSubmenuItem.focus();
					}
				}
				break;
			case 'ArrowLeft':
			case 'Escape':
				e.preventDefault();
				closeMenu(parentMenuItem, submenu);
				parentMenuItem.querySelector('.site-navigation-second__menu-link').focus();
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				if (submenu.classList.contains('site-navigation-second__sub-menu--active')) {
					closeMenu(parentMenuItem, submenu);
				} else {
					openMenu(parentMenuItem, submenu);
					closeAllMenus();
				}
				break;
		}
	};

	if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
		siblingMenus[0].addEventListener('click', (e) => {
			if (!e.target.classList.contains('site-navigation-second__menu-item--active')) {
				e.preventDefault();
				openMenu(e.currentTarget, submenu);
				closeAllMenus();
			} else {
				return true;
			}
		});
	} else {
		parentMenuItem.addEventListener('mouseover', () => {
			closeAllMenus();
			openMenu(parentMenuItem, submenu);
		});

		parentMenuItem.addEventListener('mouseout', () => {
			closeMenu(parentMenuItem, submenu);
		});

		parentMenuItem.addEventListener('keydown', handleKeyDown);
	}

	submenu.setAttribute('aria-hidden', 'true');
	parentMenuItem.setAttribute('aria-haspopup', 'true');
	parentMenuItem.setAttribute('aria-expanded', 'false');

	// Add tabindex to all menu links for focus management
	const menuLinks = submenu.querySelectorAll('.site-navigation-second__menu-link');
	menuLinks.forEach((link) => {
		link.setAttribute('tabindex', '0');
	});


}

function naviconSecond() {
	// document.querySelector('.site-navigation-second__group').addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	e.currentTarget.classList.toggle('site-navigation-second__group--active');
	// 	document.querySelector('.site-navigation-second').classList.toggle('site-navigation-second--active');
	// 	document.body.classList.toggle('site-navigation-second--open');

	// 	document.querySelector('.site-navigation-second__navicon').classList.toggle('site-navigation-second__navicon--active');
	// 	document.body.classList.toggle('site-navigation-second__navicon--open');

	// });

	const navGroup = document.querySelector('.site-navigation-second__group');
	const nav = document.querySelector('.site-navigation-second');
	const navicon = document.querySelector('.site-navigation-second__navicon');

	navGroup.addEventListener('click', (e) => {
		e.preventDefault();
		navGroup.classList.toggle('site-navigation-second__group--active');
		nav.classList.toggle('site-navigation-second--active');
		document.body.classList.toggle('site-navigation-second--open');

		navicon.classList.toggle('site-navigation-second__navicon--active');
		document.body.classList.toggle('site-navigation-second__navicon--open');
	});

	// Close menu on click outside
	document.addEventListener('click', (e) => {
		const isClickInside = navGroup.contains(e.target) || nav.contains(e.target);

		if (!isClickInside && nav.classList.contains('site-navigation-second--active')) {
			navGroup.classList.remove('site-navigation-second__group--active');
			nav.classList.remove('site-navigation-second--active');
			document.body.classList.remove('site-navigation-second--open');

			navicon.classList.remove('site-navigation-second__navicon--active');
			document.body.classList.remove('site-navigation-second__navicon--open');
		}

		const menuTxt = document.getElementById("menu");
		setTimeout(() => {
			menuTxt.innerHTML = menuTxt.innerHTML === "Close" ? "Menu" : "Close";
		}, 300);
	});
}

export { navigationSecond, naviconSecond };


